import { dsl } from '@wix/yoshi-serverless/wrap';

export const getMembersList = dsl({
          functionName: 'getMembersList',
          fileName: 'api/members/get-members-list.api',
        });